import { Location } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MainService } from '../../service/main.service';
import { ToasterServiceService } from '../../service/toaster.service';
import { ApiUrls } from '../../apiRouts';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialog } from '../../shared/confirm-dialog.component';
import { LocalStorageService } from '../../service/local-storage.service';

@Component({
  selector: 'app-member-delete',
  templateUrl: './member-delete.component.html',
  styleUrl: './member-delete.component.scss'
})
export class MemberDeleteComponent {
  deleteMemberForm: any = FormGroup;
  submitted = false;
  userId:any;
  constructor(
    private location: Location,
    private fb: FormBuilder,
    private mainService: MainService,
    private router: Router,
    public dialog: MatDialog,
    private toasterService: ToasterServiceService,
    private localStorageService : LocalStorageService) {
    this.deleteMemberForm = this.fb.group({
      contact_no: ['', [Validators.required,Validators.pattern("^[0-9]*$"),Validators.minLength(7)]],
      password: ['', [Validators.required]],
      action: '',
    })
   this.userId = this.localStorageService.getItem('user_id');
  }

  goBackToPrevPage() {
    this.location.back();
  }

  get f() {
    return this.deleteMemberForm.controls;
  }

  openDialog(): void {
    this.submitted = true;
    if(this.deleteMemberForm.valid){
    const dialogRef = this.dialog.open(ConfirmDialog, {
      data: {
        page : 'deleteAccount'
       },
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result == 1){
      this.submit();
      }
    });
  }
  }

  submit() {
      let data = {
        user_id: 0,
        name: "",
        address: "",
        contact_no: this.deleteMemberForm.value.contact_no,
        whatsapp_no: "",
        business: "",
        office_contact: "",
        office_address: "",
        village_id: 0,
        current_city_id: 0,
        education: "",
        dob: "",
        blood_group: "",
        image: "", // Assigning an empty string for image
        image_file: [], // Assigning an empty array for image_file
        relation_id: 0,
        main_member_id: 0,
        maternal_name: "",
        maternal_village_id: 0,
        is_verified: 0,
        user_type_id: 0,
        password: this.deleteMemberForm.value.password,
        created_by: 0,
        Action: ''

      };
      this.mainService.postApi(ApiUrls.userSignUp, data, 1).subscribe((res: any) => {
        if (res.status === 1) {
          if (res.user.length > 0) {
            this.deleteAccount(res.user[0].user_id);
            // this.router.navigate(['login']);
          }
          else{}
        }
      });
      this.deleteMemberForm.reset();
      this.submitted = false;
  }
  deleteAccount(user_id : any) {
    let data = {
      user_id: Number(user_id),
      name: "",
      address: "",
      contact_no: this.deleteMemberForm.value.contact_no,
      whatsapp_no: "",
      business: "",
      office_contact: "",
      office_address: "",
      village_id: 0,
      current_city_id: 0,
      education: "",
      dob: "",
      blood_group: "",
      image: "", // Assigning an empty string for image
      image_file: [], // Assigning an empty array for image_file
      relation_id: 0,
      main_member_id: 0,
      maternal_name: "",
      maternal_village_id: 0,
      is_verified: 0,
      user_type_id: 0,
      password: this.deleteMemberForm.value.password,
      created_by: 0,
      Action: 'DELETE',

    };
    this.mainService.postApi(ApiUrls.userSignUp, data, 1).subscribe((res: any) => {
      if (res.status === 1) {
         if (res.user.length > 0) {
          this.toasterService.toastSuccess('Delete successfully');
          this.router.navigate(['login']);
        }
      }
    });
  }
}


